(() => {
  const INPUT_SELECTOR = 'input[type="search"]';
  const RESULTS_SELECTOR = '[data-predictive-search]';
  const OPEN_CLASS = 'predictive-search--open';

  const debounce = (fn, delay = 200) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };

  const fetchResults = async (term) => {
    const params = new URLSearchParams({
      q: term,
      resources: JSON.stringify({
        type: ['product', 'collection', 'page', 'article'],
        limit: 8
      }),
      section_id: 'predictive-search'
    });

    const res = await fetch(`/search/suggest?${params.toString()}`, {
      headers: { Accept: 'text/html' }
    });

    if (!res.ok) throw new Error(`Predictive search failed: ${res.status}`);
    return res.text();
  };

  const init = () => {
    const input = document.querySelector(INPUT_SELECTOR);
    const resultsEl = document.querySelector(RESULTS_SELECTOR);
    if (!input || !resultsEl) return;

    const close = () => {
      resultsEl.classList.remove(OPEN_CLASS);
      resultsEl.innerHTML = '';
    };

    const openWithHtml = (html) => {
      resultsEl.innerHTML = html;
      resultsEl.classList.add(OPEN_CLASS);
    };

    const onInput = debounce(async () => {
      const term = (input.value || '').trim();
      if (term.length < 2) return close();

      try {
        const html = await fetchResults(term);
        openWithHtml(html);
      } catch (e) {
        console.warn(e);
        close();
      }
    }, 200);

    input.addEventListener('input', onInput);

    document.addEventListener('click', (e) => {
      if (e.target === input) return;
      if (resultsEl.contains(e.target)) return;
      close();
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  };

  document.addEventListener('DOMContentLoaded', init);
})();
